// This file is used for connecting session storage in browser with redux store
// So when a redux store is changed, the session storage is changed and vice versa
// Currently it's used for persistence of products added to Compare Panel by user
// It's stored in listingPage.comparison in redux store and in comparison object in session storage
import * as log from 'loglevel';
import { getFromSessionStorage, saveToSessionStorage } from '@codex/helpers';

const loadComparisionFromSessionStorage = () => {
  try {
    const serializedState = getFromSessionStorage('comparison');
    if (serializedState === null) {
      log.info("'comparison' property is not set in session storage so it's not added to store");
      return null;
    }
    return serializedState;
  } catch (err) {

    log.error(`Error during loading 'comparison' from session storage: ${err.message}`);
    return null;
  }
};

const saveComparisonToSessionStorage = (comparison) => {
  try {
    const serializedState = JSON.stringify(comparison);
    saveToSessionStorage('comparison', serializedState);
  } catch (err) {
    log.error(`Error during saving 'comparison' to session storage: ${err.message}`);
  }
};

const initComparisonPersistence = (store) => {
  store.subscribe(() => {
    saveComparisonToSessionStorage(store.getState().listingPage.comparison);
  });
};

export { loadComparisionFromSessionStorage, initComparisonPersistence };
